export default __webpack_public_path__ + "static/media/mitigation-water-damage-stairwell.cfef70ef.jpg";